import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useController } from 'react-hook-form';
import InputMask from '@mona-health/react-input-mask';
import { Input } from '../../Input';
import classNames from 'classnames';
import { PaymentIcon } from '../PaymentIcon';
import { useToggle } from 'react-use';
export const CardNumberInput = ({ control, name, size, disabled, dataTestId, className, inputClassName, onFocus, onBlur }) => {
    const [isFocused, toggleIsFocused] = useToggle(false);
    const [mask, setMask] = useState('');
    const { field, fieldState } = useController({
        name,
        control,
        rules: {
            required: {
                value: true,
                message: 'Card number is required'
            },
            validate: (v) => {
                const dryValue = v?.replace(/\s/g, '') || '';
                return (dryValue.length > 12 && dryValue.length < 17) || 'Invalid card number';
            }
        }
    });
    const hasErrors = fieldState.error;
    const isSuccess = field.value && !hasErrors;
    const paymentIconClassName = classNames('absolute z-50 flex items-center inset-y-0 gap-2', isFocused || (!isFocused && hasErrors) || !fieldState.isDirty ? 'right-3' : 'right-10');
    const handleOnBlur = (event) => {
        field.onBlur();
        onBlur?.(event);
        toggleIsFocused(false);
    };
    const handleOnFocus = (event) => {
        onFocus?.(event);
        toggleIsFocused(true);
    };
    const onCardChange = function (event) {
        const value = event.target.value;
        const amexRegex = new RegExp(/^3[47]/);
        field.onChange(value);
        setTimeout(() => {
            if (amexRegex.test(value)) {
                setMask('9999 999999 99999');
            }
            else {
                setMask('9999 9999 9999 9999');
            }
        }, 100);
    };
    return (_jsx("div", { className: "relative", children: _jsx(InputMask, { ...field, disabled: disabled, mask: mask, maskPlaceholder: null, ref: null, type: "tel", onBlur: handleOnBlur, onChange: onCardChange, onFocus: handleOnFocus, children: _jsx(Input, { autoComplete: name, className: className, dataTestId: dataTestId, disabled: disabled, errors: hasErrors, inputClassName: inputClassName, isSuccess: isSuccess, placeholder: "Card number", prePostIcon: _jsx(PaymentIcon, { cardNumber: field.value, className: paymentIconClassName, disabled: disabled }), ref: field.ref, size: size, type: "tel" }) }) }));
};
